export default __webpack_public_path__ + "assets/ico_vote_success-5f57050f.svg";